/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mt_add_row = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Row`)
};

const es_mt_add_row = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Fila`)
};

const de_mt_add_row = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Zeile`)
};

const nl_mt_add_row = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Rij`)
};

const fr_mt_add_row = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Ligne`)
};

const it_mt_add_row = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Riga`)
};

const pt_br2_mt_add_row = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Linha`)
};

const pt_mt_add_row = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Linha`)
};

const ja_mt_add_row = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ 行`)
};

const zh_mt_add_row = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ 行`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mt_add_row = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mt_add_row(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mt_add_row", locale)
	if (locale === "en") return en_mt_add_row(inputs)
	if (locale === "es") return es_mt_add_row(inputs)
	if (locale === "de") return de_mt_add_row(inputs)
	if (locale === "nl") return nl_mt_add_row(inputs)
	if (locale === "fr") return fr_mt_add_row(inputs)
	if (locale === "it") return it_mt_add_row(inputs)
	if (locale === "pt-BR") return pt_br2_mt_add_row(inputs)
	if (locale === "pt") return pt_mt_add_row(inputs)
	if (locale === "ja") return ja_mt_add_row(inputs)
	return zh_mt_add_row(inputs)
};